import I18N from '@leverege/i18n';
import { EditSettingsAction } from '@leverege/molten/data-viewers';
import Gallery from "../Gallery.js";
import GalleryEditor from "./GalleryEditor.js";
const {
  tf
} = I18N.ns('rsrc.dataViewers.Gallery.EditSettingsAction');
export default new EditSettingsAction({
  id: 'rsrc.Gallery.EditSettingsAction',
  matches: {
    use: 'actionBar',
    client: Gallery.CLIENT
  },
  editor: GalleryEditor,
  versionType: 'rsrcGallery',
  title: tf('title')
});